import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

// Supported currencies (JPY removed - zero-decimal currency requires special handling)
export const CURRENCIES = {
  USD: { symbol: '$', name: 'US Dollar', locale: 'en-US' },
  EUR: { symbol: '€', name: 'Euro', locale: 'de-DE' },
  GBP: { symbol: '£', name: 'British Pound', locale: 'en-GB' },
  CAD: { symbol: 'C$', name: 'Canadian Dollar', locale: 'en-CA' },
  AUD: { symbol: 'A$', name: 'Australian Dollar', locale: 'en-AU' }
}

export function formatCurrency(amount, currency = 'USD') {
  const currencyInfo = CURRENCIES[currency] || { symbol: currency, locale: 'en-US' }
  
  return new Intl.NumberFormat(currencyInfo.locale, {
    style: 'currency',
    currency: currency in CURRENCIES ? currency : 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount)
}

export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })
}

export function getStatusColor(status) {
  switch (status) {
    case 'draft':
      return 'status-draft'
    case 'sent':
      return 'status-sent'
    case 'partially_paid':
      return 'status-partial'
    case 'paid':
      return 'status-paid'
    case 'overdue':
      return 'status-overdue'
    default:
      return 'status-draft'
  }
}
